import React, { useState, useEffect } from 'react';

const courses = [
  {
    flag: '🇬🇧', lang: 'English',
    title: 'English Speaking — 60-Day Mastery',
    desc: 'Our flagship course. Phonetics, grammar in context, accent refinement, and daily conversation drills from beginner to advanced.',
    price: '₹4,999', duration: '60 days',
    levels: ['Beginner', 'Intermediate', 'Advanced'],
    accent: '#0ff4c6', accentBg: 'rgba(15,244,198,0.08)', accentBorder: 'rgba(15,244,198,0.2)',
  },
  {
    flag: '🇫🇷', lang: 'French',
    title: 'French Articulation & Fluency',
    desc: 'Nasal vowels, liaison rules, and conversational rhythm.',
    price: '₹4,499', duration: '8 weeks',
    levels: ['A1–A2', 'B1–B2', 'C1–C2'],
    accent: '#f472b6', accentBg: 'rgba(244,114,182,0.08)', accentBorder: 'rgba(244,114,182,0.2)',
  },
  {
    flag: '🇰🇷', lang: 'Korean',
    title: 'Korean — Hangul to Conversation',
    desc: 'From script mastery to natural speech.',
    price: '₹4,299', duration: '10 weeks',
    levels: ['Beginner', 'Intermediate', 'Advanced'],
    accent: '#fbbf24', accentBg: 'rgba(251,191,36,0.08)', accentBorder: 'rgba(251,191,36,0.2)',
  },
];

export default function Courses() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section
      id="courses"
      style={{
        padding: isMobile ? '3rem 1rem' : '5rem 2rem',
        background: 'var(--bg)',
      }}
    >
      <div style={{ maxWidth: '1120px', margin: '0 auto' }}>

        {/* Header */}
        <div style={{ marginBottom: isMobile ? '2rem' : '3rem' }}>
          <div style={{
            fontSize: '11px',
            fontWeight: '700',
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            color: '#0ff4c6',
            marginBottom: '10px'
          }}>
            Our courses
          </div>

          <h2 style={{
            fontSize: 'clamp(24px, 5vw, 46px)',
            fontWeight: '800',
            marginBottom: '0.5rem',
            color: '#f0f4ff'
          }}>
            Courses we offer
          </h2>

          <p style={{
            fontSize: isMobile ? '14px' : '15px',
            color: '#94a3c4',
            marginBottom: '1.5rem',
            maxWidth: '480px'
          }}>
            Choose the language that fits your goal — each comes with a free demo class.
          </p>
        </div>

        {/* Grid */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', // ✅ better responsive
          gap: '16px',
        }}>
          {courses.map((c, i) => (
            <div key={i} style={{
              background: 'var(--surface)',
              border: `1px solid ${c.accentBorder}`,
              borderRadius: '20px',
              overflow: 'hidden',
              transition: 'all 0.25s',
            }}>

              {/* Top */}
              <div style={{
                background: c.accentBg,
                borderBottom: `1px solid ${c.accentBorder}`,
                height: isMobile ? '70px' : '90px', // ✅ responsive height
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '0 1.2rem',
              }}>
                <span style={{ fontSize: isMobile ? '32px' : '44px' }}>
                  {c.flag}
                </span>

                <span style={{
                  fontSize: '12px',
                  fontWeight: '700',
                  color: c.accent,
                }}>
                  {c.lang}
                </span>
              </div>

              {/* Content */}
              <div style={{ padding: isMobile ? '1.2rem' : '1.5rem' }}>
                <h4 style={{
                  fontSize: isMobile ? '14px' : '16px',
                  fontWeight: '700',
                  color: '#f0f4ff',
                  marginBottom: '8px',
                }}>
                  {c.title}
                </h4>

                <p style={{
                  fontSize: '13px',
                  color: '#94a3c4',
                  marginBottom: '1rem',
                }}>
                  {c.desc}
                </p>

                {/* Tags */}
                <div style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  gap: '6px',
                  marginBottom: '1rem',
                }}>
                  {c.levels.map(l => (
                    <span key={l} style={{
                      fontSize: '11px',
                      padding: '3px 10px',
                      borderRadius: '999px',
                      background: c.accentBg,
                      color: c.accent,
                      border: `1px solid ${c.accentBorder}`,
                    }}>
                      {l}
                    </span>
                  ))}
                  <span style={{
                    fontSize: '11px',
                    padding: '3px 10px',
                    borderRadius: '999px',
                    background: 'rgba(99,179,237,0.06)',
                    color: '#94a3c4',
                  }}>
                    {c.duration}
                  </span>
                </div>

                {/* Price + Button */}
                <div style={{
                  display: 'flex',
                  flexDirection: isMobile ? 'column' : 'row', // ✅ FIX
                  gap: '10px',
                  justifyContent: 'space-between',
                  alignItems: isMobile ? 'flex-start' : 'center',
                }}>
                  <div>
                    <div style={{ fontSize: '11px', color: '#4a5878' }}>
                      Starting from
                    </div>
                    <div style={{
                      fontSize: isMobile ? '20px' : '22px',
                      fontWeight: '800',
                      color: c.accent,
                    }}>
                      {c.price}
                    </div>
                  </div>

                  <button style={{
                    width: isMobile ? '100%' : 'auto',
                    background: c.accent,
                    color: '#080b14',
                    border: 'none',
                    padding: '10px 18px',
                    borderRadius: '999px',
                    fontSize: '13px',
                    fontWeight: '600',
                    cursor: 'pointer',
                  }}>
                    Enroll →
                  </button>
                </div>

              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}